import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, IAppSettings } from '../../services/configuration/configuration.service';

@Component({
  selector: 'oir-module-info',
  templateUrl: './module-info.component.html',
  styleUrls: ['./module-info.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleInfoComponent implements OnInit {
  @Input() logOutPath;
  @Input() prod = true;

  userName;
  versionNumber;

  constructor(private configuration: ConfigurationService<IAppSettings>) {}

  ngOnInit(): void {
    this.userName = this.configuration.getValue('FullName') ? this.configuration.getValue('FullName') : '';
    this.versionNumber = this.configuration.getValue('VersionNumber') ? this.configuration.getValue('VersionNumber') : '0.0.0';
  }
}
